import React from 'react';
import { HeroImage } from '@sls-react/components/Homepage/Elements';
import { RailsBlock } from '@sls-react/typings/services/rails/tile';
import useTileVersion from '@sls-react/hooks/useTileVersion';
import classNames from 'classnames';

interface Props {
  block: RailsBlock;
  headerType: 'h1' | 'h2';
}

const LanderHeaderBlock: React.FC<Props> = ({ block, headerType }) => {
  const tileVersion = useTileVersion(block);

  const title = block.title || tileVersion.title;
  const subtitle = tileVersion.subtitle;
  const destination = block.destination || tileVersion.destination;
  const backgroundColor = block.background_color;
  const textColor =
    block.text_color ||
    tileVersion.text_color ||
    (backgroundColor ? '#fff' : '');

  const content = (
    <div
      className={classNames(
        'relative mb-4 py-10',
        tileVersion.background_image_url && 'min-h-[120px]',
      )}
      style={{
        backgroundColor,
      }}
    >
      {tileVersion.background_image_url && (
        <HeroImage alt={block.title} src={tileVersion.background_image_url} />
      )}

      <div
        className={classNames(
          'container mb-0 relative flex flex-col space-y-4 justify-center',
          tileVersion.halignment === 'right'
            ? 'text-right'
            : tileVersion.halignment === 'center'
            ? 'text-center'
            : 'text-left',
        )}
        style={{
          zIndex: 1,
        }}
      >
        {subtitle && (
          <div
            className="text-base"
            style={{
              color: textColor,
            }}
          >
            {subtitle}
          </div>
        )}

        {title &&
          React.createElement(
            headerType,
            {
              style: {
                marginTop: subtitle ? 8 : 0,
              },
            },
            <span
              className="text-4xl font-bold"
              style={{
                color: textColor,
              }}
            >
              {title}
            </span>,
          )}
      </div>
    </div>
  );

  if (destination) {
    return (
      <a href={destination} className="block">
        {content}
      </a>
    );
  }

  return content;
};

export default LanderHeaderBlock;
